export default "__VITE_ASSET__C2E5H3Bo__"